//Sort by lowest price
export const sortByMinPrice = (properties: any) => {
  properties.sort((a: any, b: any) => { return a.fields.ListingPrice - b.fields.ListingPrice })
};

//Sort by highest price
export const sortByMaxPrice = (properties: any) => {
  properties.sort((a: any, b: any) => { return (a.fields.ListingPrice - b.fields.ListingPrice) })
  properties.reverse()
};

//Sort by lowest sq footage
export const sortByMinSqFt = (properties: any) => {
  properties.sort((a: any, b: any) => { return a.fields.SqFt - b.fields.SqFt })
};

//Sort by highest sq footage
export const sortByMaxSqFt = (properties: any) => {
  properties.sort((a: any, b: any) => { return a.fields.SqFt - b.fields.SqFt })
  properties.reverse()
};

//Filter by Zipcode
export const zipcodeValidation = (properties: any, zip: any):boolean => {
  return properties.filter((property: any) => property.fields.ZipCode === zip)
}

//Filter by State
export const filterByState = (properties: any, state: string) => {
  return properties.filter((property: any) => property.fields.State === state)
};

//Filter by Minimum Price
export const filterMinPrice = (properties: any, minPrice: number) => {
  return properties.filter((property: any) => property.fields.ListingPrice >= minPrice)
};

//Filter by Maximum Price
export const filterMaxPrice = (properties: any, maxPrice: number) => {
  return properties.filter((property: any) => property.fields.ListingPrice <= maxPrice)
};

//Min Number of bedrooms
export const filterMinBedrooms = (properties: any, rooms: number) => {
  return properties.filter((property: any) => property.fields.Beds >= rooms)
};

//Max Number of bathrooms
export const filterMaxBedrooms = (properties: any, rooms: number) => {
  return properties.filter((property: any) => property.fields.Beds <= rooms)
};

//Min Number of bathrooms
export const filterMinBathrooms = (properties: any, rooms: number) => {
  return properties.filter((property: any) => property.fields.Baths >= rooms)
};

//Max Number of bathrooms
export const filterMaxBathrooms = (properties: any, rooms: number) => {
  return properties.filter((property: any) => property.fields.Baths <= rooms)
};

//Min Sq footage
export const filterMinSqFt = (properties: any, minSqFt: number) => {
  return properties.filter((property: any) => property.fields.SqFt >= minSqFt)
};

//Max Sq footage
export const filterMaxSqFt = (properties: any, maxSqFt: number) => {
  return properties.filter((property: any) => property.fields.SqFt <= maxSqFt)
};

//Amenities
export const filterHasYard = (properties: any) => {
  return properties.filter((property: any) => property.fields.HasYard == 'true')
};

export const filterHasAC = (properties: any) => {
  return properties.filter((property: any) => property.fields.HasAC == 'true')
}

export const filterParking = (properties: any) => {
  return properties.filter((property: any) => property.fields.Parking?.[0] === ('Driveway' || 'Garage' || 'Dedicated-Spot' || 'Car port' || 'On-street'))
}

export const filterPool = (properties: any) => {
  return properties.filter((property: any) => property.fields.Pool == 'true')
}